import { Reveal } from "./Reveal";

const QUOTES = [
  {
    text: "I was deeply blessed to experience a 1 to 1 session with Amaléya. She holds space for powerful shifts to come through in such a gentle and loving way. Her insights were spot on and resonated deeply, she felt into my energy and made me feel like I wasn't alone in feeling the big feelings. Her guidance on how to work with the energy after as well was beautifully received. She flowed through the session with grace and was a beautiful reminder of divine feminine energy in power and purpose. Deep gratitude beautiful sistar",
    name: "Sonia",
    detail: "1 to 1 session",
  },
];

export const Testimonials = () => (
  <section
    data-testid="testimonials-section"
    className="px-6 md:px-12 py-28 md:py-40 lg:py-48"
  >
    <div className="max-w-6xl mx-auto">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-amethyst font-medium mb-6">
          Words from the Journey
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-none text-soil max-w-3xl">
          Softened. <span className="italic text-amethyst">Steadied.</span>{" "}
          Returned.
        </h2>
      </Reveal>
      <div className={QUOTES.length > 1 ? "mt-20 md:mt-28 grid md:grid-cols-3 gap-12 md:gap-10" : "mt-20 md:mt-28 max-w-3xl"}>
        {QUOTES.map((q, i) => (
          <Reveal
            key={q.name}
            delay={0.1 * i}
            y={36}
            className={QUOTES.length > 1 ? (i === 1 ? "md:mt-16" : i === 2 ? "md:mt-32" : "") : ""}
          >
            <figure data-testid={`testimonial-${i + 1}`} className="relative">
              <span className="font-serif text-gold text-7xl leading-none block -mb-6 select-none">
                “
              </span>
              <blockquote className="font-serif text-xl md:text-2xl text-soil leading-relaxed">
                {q.text}
              </blockquote>
              <figcaption className="mt-6">
                <span className="text-xs uppercase tracking-[0.25em] text-amethyst">
                  {q.name}
                </span>
                <span className="block text-xs text-clay/70 mt-1 tracking-wide">
                  {q.detail}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
